import React, { Component } from 'react'

export default class TextField extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { item, remarkFlag } = this.props
    if(remarkFlag === 1) {
      return(
        <dl>
          <dt>{item.input_name}</dt>
          <dd>
            <input type="text" name size={25} />
            <p className="cap">{item.input_remaks}</p>
          </dd>
        </dl>
      )
    }
    return(
      <dl>
        <dt>{item.input_name}</dt>
        <dd>
          <input type="text" name size={25} placeholder={item.input_remaks}/>
        </dd>
      </dl>
    )
  }
}
